module.exports = __webpack_public_path__ + "img/40_70_001_743.d415378d.jpg";